import React, { Component } from 'react';

import ReactGA from 'react-ga';

import InstructorList from './scenes/Organizer/InstructorList';
import CourseDetail from './scenes/Organizer/CourseDetail';
import SemesterList from './scenes/Organizer/SemesterList';

class OrganizerSceneCoordinator extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedCourse: null,
    };

    this.handleCourseSelected = this.handleCourseSelected.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview('/organizer');
  }

  handleCourseSelected(item) {
    this.setState({selectedCourse: item});
  }

  render() {
    return (
      <div className="scene-box">
        <SemesterList onChildItemSelected={this.handleCourseSelected}/>
        <CourseDetail item={this.state.selectedCourse} />
        <InstructorList />
      </div>
    );
  }
}

export default OrganizerSceneCoordinator;


// WEBPACK FOOTER //
// ./src/OrganizerSceneCoordinator.js